import React, { Component, Fragment } from "react"
import { createPortal } from "react-dom"

import withContext from "../withContext"

import Formulas from "../attributes/items/form/Formulas"
import styled from "react-emotion"

import { ATTR_NAME } from "../BlockVisibility"
import RenderRowAttribute from "../attributes/RenderRowAttribute"
import { ThemeProvider } from "emotion-theming"
import smallDarkTheme from "features/editor/ui/smallDarkTheme"

import MenuSection from "features/editor/ui/MenuSection"
import { Label, Button, Container, Collapsible, Icon } from "ui"
import { getBlockByType } from "../blockTypes"
import BlockActionList from "../attributes/items/actions/BlockActionList"

/**
 * ? date: StackerCon 2018
 * initial goal: being able to toggle block's visibility, based on formulas
 * initial implementation assumptions: we will use this to also add, ie., the ability to select the action on click
 *
 * @see ../attributes/items/form/Formulas.js
 * @see ../blockVisibility.js
 *
 * @author laurent
 *
 * @augments {Component<{context: BlockContext}>}
 */
class BehaviorPortal extends Component {
    render() {
        const { context } = this.props
        const blockType = getBlockByType(context.block.type)
        const showOnClick =
            blockType.blockElement.behaviours && blockType.blockElement.behaviours.onClick
        const result = (
            <ThemeProvider theme={smallDarkTheme}>
                <div
                    onClick={event => {
                        event.stopPropagation()
                    }}
                >
                    <Collapsible
                        container={MenuSection(
                            <Fragment>
                                <Icon icon="eye" /> Visibility
                            </Fragment>,
                            { margin: "none" }
                        )}
                        defaultOpen
                    >
                        <Container padding="none" margin="none">
                            <RenderRowAttribute
                                label={<React.Fragment>Show block if</React.Fragment>}
                                field={ATTR_NAME}
                                params={context.block.config.attributes}
                                setAttr={(attr, value) =>
                                    context.actions.updateAttributes(context.block.id, attr, value)
                                }
                                render={props => <Formulas {...props} />}
                            />
                        </Container>
                        <Button
                            onClick={() =>
                                context.actions.updateAttributes(context.block.id, ATTR_NAME)
                            }
                        >
                            Clear
                        </Button>
                    </Collapsible>
                    {showOnClick && (
                        <Collapsible
                            container={MenuSection(
                                <Fragment>
                                    <Icon icon="bolt" /> On Click
                                </Fragment>,
                                { margin: "none" }
                            )}
                            defaultOpen
                        >
                            <Container padding="none" margin="none">
                                <RenderRowAttribute
                                    label={<React.Fragment>When block is clicked</React.Fragment>}
                                    field={"actions"}
                                    params={context.block.config.attributes}
                                    setAttr={(attr, value) =>
                                        context.actions.updateAttributes(
                                            context.block.id,
                                            attr,
                                            value
                                        )
                                    }
                                    render={props => <BlockActionList {...props} />}
                                />
                            </Container>
                        </Collapsible>
                    )}
                </div>
            </ThemeProvider>
        )

        return createPortal(result, document.getElementById("blockActions"))
    }
}

export default withContext(BehaviorPortal)



// WEBPACK FOOTER //
// ./src/features/editor/block/BehaviorPortal.js